module.exports = __webpack_public_path__ + "static/media/PM51.7e4f0249.JPG";